import { api, handleResponse, handleError } from "./apiServices";
const baseURL = `api/venueRoom/`;
export const getRoom = (token, id, data) =>
  api(token)
    .post(`${baseURL}getAll/${id}`, data)
    .then(handleResponse)
    .catch(handleError);

export const getallRooms = (token, data) =>
  api(token)
    .get(`${baseURL}getallrooms`, data)
    .then(handleResponse)
    .catch(handleError);

export const addRoom = (token, data) =>
  api(token)
    .post(`${baseURL}create`, data)
    .then(handleResponse)
    .catch(handleError);

export const editRoom = (token, id, data) =>
  api(token)
    .put(`${baseURL}edit/${id}`, data)
    .then(handleResponse)
    .catch(handleError);

export const deleteRoom = (token, id) =>
  api(token)
    .delete(`${baseURL}delete/${id}`)
    .then(handleResponse)
    .catch(handleError);

export const changeRoomStatus = (token, id, data) =>
  api(token)
    .put(`${baseURL}update-status/${id}`, data)
    .then(handleResponse)
    .catch(handleError);

export const send_room_key = (token, id) =>
  api(token)
    .post(`${baseURL}send_room_key`, id)
    .then(handleResponse)
    .catch(handleError);

export const view_room = (token, id) =>
  api(token)
    .get(`${baseURL}view/${id}`)
    .then(handleResponse)
    .catch(handleError);

export const getRoomsByVenue = (token, id, data) =>
  api(token)
    .get(`${baseURL}getRoomsByVenue/${id}`, { params: data })
    .then(handleResponse)
    .catch(handleError);
